// Los datos se cargan a mano en la planilla, así que el mismo valor puede
// venir como "Chascomús", "CHASCOMUS", "chascomus ", etc. Estas funciones
// unifican esas variantes para los filtros.

const PALABRAS_MINUSCULAS = ["de", "del", "la", "las", "los", "el", "y", "en"];

const ACENTOS_REGEX = /[\u0300-\u036f]/;

// Clave de comparación: sin espacios extra, sin tildes y en minúsculas.
export const normalizeKey = (value) =>
  String(value ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase()
    .normalize("NFD")
    .replace(new RegExp(ACENTOS_REGEX, "g"), "");

const hasAccents = (value) =>
  ACENTOS_REGEX.test(String(value).normalize("NFD"));

// "CHASCOMÚS" -> "Chascomús", "mar del plata" -> "Mar del Plata"
export const toDisplayName = (value) =>
  String(value ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word, index) =>
      index > 0 && PALABRAS_MINUSCULAS.includes(word)
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");

// Devuelve la lista de opciones únicas ya normalizadas para mostrar.
// Si hay variantes con y sin tilde, se queda con la que tiene tilde.
export const uniqueDisplayValues = (values) => {
  const byKey = new Map();

  values.forEach((value) => {
    const key = normalizeKey(value);
    if (!key) return;

    const display = toDisplayName(value);
    const existing = byKey.get(key);

    if (!existing || (!hasAccents(existing) && hasAccents(display))) {
      byKey.set(key, display);
    }
  });

  return [...byKey.values()].sort((a, b) => a.localeCompare(b, "es"));
};
